import { useTranslation } from 'react-i18next'

export function Footer() {
  const { t } = useTranslation()
  return (
    <footer className="footer" role="contentinfo">
      <div>{t('footer.copyright')}</div>
      <div>
        <a href={t('links.support')}>{t('footer.support')}</a>
        {' · '}
        <a href={t('links.privacyPolicy')}>{t('footer.privacyPolicy')}</a>
        {' · '}
          <a href={t('links.cookiePolicy')}>{t('footer.cookiePolicy')}</a>
          {' · '}
        <a href={t('links.termsOfUse')}>{t('footer.termsOfUse')}</a>
      </div>
    </footer>
  )
}
